import { render, staticRenderFns } from "./Promotion_details.vue?vue&type=template&id=761e2990&scoped=true&"
import script from "./Promotion_details.vue?vue&type=script&lang=js&"
export * from "./Promotion_details.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_details.vue?vue&type=style&index=0&id=761e2990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e2990",
  null
  
)

export default component.exports